import type { ComponentProps } from 'react';
import { useMemo } from 'react';
// local
import type { TFormFieldUpdater } from '../FormFieldUpdater';
import FormFieldUpdater from '../FormFieldUpdater';
// types
import { type TFormRange } from '@hubertai/screening-question-types';
import { useTranslation } from 'react-i18next';
interface Props extends ComponentProps<'div'> {
  form: TFormRange;
  formIndex: number;
}

const CreateFormRange = ({ form, formIndex, ...props }: Props) => {
  const { t } = useTranslation('Questionsv2');
  const formFieldValues: TFormFieldUpdater[] = useMemo(
    () => [
      {
        label: t('form.range.labelLeft.label'),
        description: t('form.range.labelLeft.description'),
        formKey: 'label_left',
        fieldType: 'rich-text',
        formValuesKey: 'labelLeft',
        form,
        formIndex,
      },
      {
        label: t('form.range.labelRight.label'),
        description: t('form.range.labelRight.description'),
        formKey: 'label_right',
        fieldType: 'rich-text',
        formValuesKey: 'labelRight',
        form,
        formIndex,
      },
      {
        label: t('form.range.unit.label'),
        description: t('form.range.unit.description'),
        formKey: 'unit',
        fieldType: 'rich-text',
        formValuesKey: 'unit',
        form,
        formIndex,
      },
      {
        label: t('form.range.min.label'),
        description: t('form.range.min.description'),
        formKey: 'min',
        fieldType: 'number',
        formValuesKey: 'min',
        form,
        formIndex,
      },
      {
        label: t('form.range.max.label'),
        description: t('form.range.max.description'),
        formKey: 'max',
        fieldType: 'number',
        formValuesKey: 'max',
        form,
        formIndex,
      },
      {
        label: t('form.range.step.label'),
        description: t('form.range.step.description'),
        formKey: 'step',
        fieldType: 'number',
        formValuesKey: 'step',
        form,
        formIndex,
      },
    ],
    [t, form, formIndex],
  );

  return (
    <div {...props}>
      {formFieldValues.map((x, index) => {
        return (
          <FormFieldUpdater
            key={`form-field-updater-${form.id}-${index}`}
            label={x.label}
            description={x.description}
            formKey={x.formKey}
            fieldType={x.fieldType}
            formValuesKey={x.formValuesKey}
            form={x.form}
            formIndex={x.formIndex}
          />
        );
      })}
    </div>
  );
};

export default CreateFormRange;
